(() => {
  const modalSelector = '[data-quick-add-modal][data-hide-unavailable-options]';
  const unavailableOptionSelectors = [
    '.radio__button input.disabled',
    '.radio__button input.sold-out',
    '.radio__button input.unavailable',
    '.swatch-input__input.visually-disabled',
    '.swatch-input__input.unavailable',
    '.select-popout__option.unavailable',
  ];

  const removeUnavailableOption = (element) => {
    element.closest('.radio__button, tooltip-component, .select-popout__item')?.remove();
  };

  const removeUnavailableOptions = (modal) => {
    if (!modal?.matches?.(modalSelector)) return;

    modal.querySelectorAll(unavailableOptionSelectors.join(',')).forEach(removeUnavailableOption);
  };

  const removeOpenModalUnavailableOptions = () => {
    document.querySelectorAll(modalSelector).forEach(removeUnavailableOptions);
  };

  document.addEventListener('theme:quick-add:open', removeOpenModalUnavailableOptions);
  document.addEventListener('shopify:section:load', removeOpenModalUnavailableOptions);
})();
